import { ChangeDetectionStrategy, Component, computed, input, output } from '@angular/core';
import { SvgComponent } from '../../../shared/components/svg/svg.component';
import { ButtonDirective } from '../../../shared/directives/button.directive';
import { TooltipDirective } from '../../../shared/directives/tooltip.directive';

@Component({
  selector: 'app-document-viewer-controls',
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './document-viewer-controls.component.html',
  styleUrls: ['./document-viewer-controls.component.scss'],
  imports: [SvgComponent, ButtonDirective, TooltipDirective],
})
export class DocumentViewerControlsComponent {
  page = input.required<number>();
  totalPages = input.required<number>();
  pageChange = output<number>();

  canNext = computed(() => this.page() < this.totalPages() - 1);
  canPrevious = computed(() => this.page() > 0);

  previousPage() {
    if (this.page() > 0) {
      this.pageChange.emit(this.page() - 1);
    }
  }

  nextPage() {
    if (this.page() < this.totalPages() - 1) {
      this.pageChange.emit(this.page() + 1);
    }
  }
}
